import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SetPromoCode } from '../../../actions/currentBooking';
import { FetchDiscount, DiscountValid } from '../../../actions/discount';
import { ToggleFooterModal } from '../../../actions/utils';
import debounce from 'lodash/debounce';
import {store} from '../../../index';
import { get } from '../../../helpers/objectHelper';


class Promocode extends PureComponent{

  constructor(props){
    super(props);
    this.state = {
      promoCode:"",
      promoMessage:"",
      discountLoading:false,
      isTouched:false
    }
    this.onPromoclick = this.onPromoclick.bind(this);
    this.termsHandler = this.termsHandler.bind(this);
  }



  onPromoclick(){
    const { currency:{iso_currency_code}, SetPromoCode, FetchDiscount, currentTrip:{departure_date} } = this.props;
    const { promoCode } = this.state;

    if(promoCode !== "" && departure_date !== ""){
      this.setState({discountLoading:true});
      SetPromoCode(promoCode);
      FetchDiscount(store.getState().currentBooking, iso_currency_code );
    }
    if(departure_date === ""){
      this.setState({promoMessage:"Please select a calender date"})
    }
  }


  componentDidUpdate(prevProps, prevState) {


    const { discount, DiscountValid } = this.props;
    const { promoCode } = this.state;

    //check if promo code is valid and display message
    if(discount !== prevProps.discount){

      this.setState({discountLoading:false});

      //Toggle discount message
      if(Object.keys(discount.data).length && discount.data.bookings[0].client_bookings.length !== 0){
        if(discount.data.bookings[0].client_bookings[0].discount > 0){
          DiscountValid(true);
          this.setState({promoMessage:get(['data', 'bookings', 0, 'client_bookings', 0, 'discount_description'], discount, "")});
        }else{
          DiscountValid(false);
          this.setState({promoMessage:"Sorry '" + promoCode + "' is an invalid discount code"});
        }
      }else{
        DiscountValid(false);
        this.setState({promoMessage:"Sorry '" + promoCode + "' is an invalid discount code"});
      }


      //Reset discount message and input field promo code
      if(Object.keys(discount.data).length === 0 && !discount.valid){
        this.setState({promoMessage:"", promoCode:""});
        document.querySelector('.promo-code .promo-container .material-input').classList.remove('hovered');
      }

    }

  }

  termsHandler(e){
    if(this.props.basketType === ""){
      e.preventDefault();
      this.props.ToggleFooterModal(e.target.href, true);
    }
  }


  render(){

    const { promoCode, promoMessage, discountLoading, isTouched } = this.state;
    const { discount:{valid} } = this.props;


    return (
      <React.Fragment>
        <div className="promo-code">
          <div className="row">

              <div className="promo-container">

                <div className="columns small-12">
                  <p className={`promoMessage ${(valid) ? 'valid' : ''}`} style={{
                    'display': `${ (promoMessage.length !== 0) ? "inline-block" : "none" }` 
                    }}>
                    {promoMessage} &nbsp;
                    <span className="terms-text" style={{'display': `${ valid ? "inline-block" : "none" }` }}>
                      <a href="https://www.busabout.com/terms-conditions?SQ_DESIGN_NAME=simple" target="_blank" rel="noopener noreferrer" className="busabout--cta--link orange" onClick={e => this.termsHandler(e)}> Terms apply</a>.
                    </span>
                  </p>
                </div>

                <div className="columns small-12">
                  <div className="material-input">
                    <label htmlFor="promocode" className="">
                      <span>Do you have a discount code?</span>
                      <input
                        type="text"
                        name="promocode"
                        value={promoCode}
                        id="promocode"
                        className="input-control"
                        onClick={(e) => { this.setState({isTouched:true}) } }
                        onBlur={(e) => { if(e.target.value === "") e.target.parentElement.parentElement.classList.remove('hovered'); } }
                        onChange={ (e) => { this.setState({promoCode:e.target.value.trim()}) } }
                        onFocus={(e) => { e.target.parentElement.parentElement.classList.add('hovered'); } }
                      />
                    </label>
                  </div>
                <button type="button" className={`busabout--cta ${isTouched ? 'active' : ''}`} onClick={debounce(this.onPromoclick, 1250, {'leading': true, 'trailing': false}) }>
                  <span style={{display:discountLoading ? 'none' : 'block'}}>
                    <svg width="16" height="13" viewBox="0 0 16 13" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14.3.2L5 9.3 1.7 6a.4.4 0 0 0-.6 0l-1 1v.5l4.7 4.7c.2.2.4.2.6 0L15.9 1.7v-.6l-1-1a.4.4 0 0 0-.6 0z" fill="#FFF" fillRule="nonzero"/>
                    </svg>
                  </span>
                  <span style={{display:discountLoading ? 'block' : 'none'}}><span className="fa fa-spinner fa-spin fa-lg"></span></span>
                </button>
                </div>
              </div>

          </div>
        </div>

      </React.Fragment>
    )
  }
}


function mapStateToProps(state){
  return{
    currency:state.currency,
    processing:state.currentBooking.processing,
    currentTrip:state.currentBooking.trips[0],
    discount:state.discount,
    currentBooking:state.currentBooking
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    SetPromoCode,
    FetchDiscount,
    DiscountValid,
    ToggleFooterModal
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Promocode);


// WEBPACK FOOTER //
// ./src/components/basket/components/promocode.js